var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsersThree = function SvgUsersThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.015 18.475a.5.5 0 0 1-.5.525H2a1 1 0 0 1-.975-.771 1.04 1.04 0 0 1 .203-.866 8.5 8.5 0 0 1 3.397-2.674 5 5 0 1 1 8.308-4.475.49.49 0 0 1-.284.522 8.01 8.01 0 0 0-4.634 7.739m22.75-1.114a8.47 8.47 0 0 0-3.39-2.672 5 5 0 1 0-8.308-4.475.49.49 0 0 0 .284.522A8.01 8.01 0 0 1 24 18c0 .16 0 .317-.015.475a.5.5 0 0 0 .5.525H30a1 1 0 0 0 .975-.771 1.04 1.04 0 0 0-.204-.868zM19.64 22.76a6 6 0 1 0-7.296 0 9 9 0 0 0-4.21 3.741A1 1 0 0 0 9 28h14a1 1 0 0 0 .866-1.5 9.02 9.02 0 0 0-4.217-3.741z"
  })));
};
export default SvgUsersThree;